import { useContext, useState } from "react";
import { Context } from "../../App";
import { Stack, Box, Typography, Button, Backdrop, CircularProgress } from "@mui/material";

export default function CmdDelete({commande, close, manage_snackbar, updateCommandes}) {
    const { setIsConnected } = useContext(Context)
    const [load, setLoad] = useState(false)

    function handleSubmit() {
        setLoad(true)
        const query = new URLSearchParams({_id: commande._id}).toString();

        fetch(process.env.REACT_APP_API_URL+'/adm/commandes?'+query, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.ok) {
                    updateCommandes();
                    manage_snackbar(true, "Commande supprimée avec succès");
                    close();
                }
            }
        }).catch(error => {
            console.error("Error fetching commandes:", error);
        }).finally(() => {
            setLoad(false);
        });
    }

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 2}}>
            <Typography variant="h4" gutterBottom sx={{color: 'focus.main', align:'center'}}>Suppression</Typography>
            <Typography variant="body1" fontWeight={500} gutterBottom align="center">Êtes-vous sûr de vouloir supprimer la commande N°{commande.num} et {commande.items.length>1 ? `ces ${commande.items.length} billets` : `son billet`} en pré-commande ?</Typography>

            <Stack direction="row" spacing={2} sx={{marginTop: 2, alignSelf:'end'}}>
                <Button variant="outlined" color="focus" onClick={close}>Annuler</Button>
                <Button variant="contained" color="focus" sx={{color: "white"}} onClick={handleSubmit}>Confirmer</Button>
            </Stack>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )

}